import axios from "axios";
import { normalizeEtfHoldingsResponse } from "./etf.normalize";
import type { EtfHoldingsResponse } from "./etf.type";

/**
 * Our own server's proxy (src/routes/data.etf-holdings.ts): the gateway route
 * needs a key that must not reach the browser. Same origin, open to every
 * visitor.
 */
export const etfHoldingsProxyPath = (ticker: string) =>
  `/data/etf/${encodeURIComponent(ticker)}/holdings`;

export const getEtfHoldings = async (
  ticker: string,
  page: number,
  limit: number,
  options?: { signal?: AbortSignal },
): Promise<EtfHoldingsResponse> => {
  const response = await axios.get<unknown>(etfHoldingsProxyPath(ticker), {
    params: { page, limit },
    signal: options?.signal,
  });
  return normalizeEtfHoldingsResponse(response.data, limit);
};
